<template>
  <div id="new-lo-title-create">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-title class="text-h5">
        <h2>{{ PageTitle }}</h2>
      </v-card-title>

      <v-card-subtitle class="text-h5">
        <h4>{{ PageDescription }}</h4>
      </v-card-subtitle>

      <v-card-text>
        <v-row wrap>
          <v-col align="center" cols="12" md="12">
            <v-btn
              large
              @click.prevent="backPage"
              color="#EDBE38"
              elevation="30"
              shaped
              class="font-size-h6 fsize-3 mr-3 my-3 white--text"
            >
              <v-icon dark>mdi-arrow-left-circle</v-icon>&nbsp; Back
            </v-btn>
            <v-btn
              large
              @click.prevent="refreshPageData"
              color="#EDBE38"
              elevation="30"
              shaped
              class="font-size-h6 mr-3 my-3 white--text"
            >
              <v-icon dark>mdi-refresh</v-icon>&nbsp; Refresh
            </v-btn>
          </v-col>
        </v-row>
        <br />
        <br />
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container v-if="StartupLoadingFlag">
          <v-row wrap>
            <v-col cols="12" md="4" v-for="n in 6" :key="n">
              <v-skeleton-loader
                v-bind="attrs"
                type="paragraph"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
        <v-form
          ref="form2"
          v-model="valid"
          lazy-validation
          v-on:submit.prevent="confirmAlert"
        >
          <v-container v-if="!StartupLoadingFlag">
            <v-card elevation="3" outlined>
              <v-card-title>
                <span> Sponsor LO details &nbsp; </span>
              </v-card-title>
              <v-container>
                <v-row wrap>
                  <v-col cols="12" sm="6" md="3">
                    <label>
                      <h6>
                        <span class="text-danger">*</span> President Details
                      </h6>
                    </label>
                    <v-img
                      :src="Member.MemberImagePath"
                      :alt="Member.MemberName"
                      lazy-src="/no-image-available.png"
                      max-width="100"
                      max-height="100"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <br />
                    <h4>{{ Member.MemberName }}</h4>
                    <h4>{{ Member.MembershipId }}</h4>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label>
                      <h6><span class="text-danger">*</span> LO</h6>
                    </label>
                    <h4>{{ Member.LomName }}</h4>
                    <h4>{{ Member.ZoneName }}</h4>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label>
                      <h6><span class="text-danger">*</span> Mobile Number</h6>
                    </label>
                    <v-text-field
                      v-model="Member.PrimaryMobile"
                      :rules="MobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="Enter your mobile number"
                      dense
                      outlined
                    ></v-text-field>
                    <!-- <h4>{{ Member.MobileNo }}</h4> -->
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label>
                      <h6><span class="text-danger">*</span> Email Id</h6>
                    </label>
                    <v-text-field
                      v-model="Member.EmailId"
                      :rules="EmailIdRules"
                      type="email"
                      hint="Enter your email id"
                      dense
                      outlined
                    ></v-text-field>
                    <!-- <h4>{{ Member.EmailId }}</h4> -->
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-card elevation="3" outlined>
              <v-card-title>
                <span> New LO details &nbsp; </span>
              </v-card-title>
              <v-container>
                <v-row wrap>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>
                        <span class="text-danger">*</span> Choose from approved
                        LO name
                      </h6>
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="NewLomCodeOptionsLoading"
                      :items="NewLomCodeOptions"
                      :rules="NewLomCodeRules"
                      v-model="NewLomCode"
                      required
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label>
                      <h6>Selected LO Name</h6>
                    </label>
                    <br />
                    <h4>{{ SelectedLom.NewLomsName }}</h4>
                    <h4>{{ SelectedLom.StateName }}</h4>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <label>
                      <h6>Paid Date</h6>
                    </label>
                    <br /><br />
                    <h4>{{ SelectedLom.OrdersDateTxt }}</h4>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <label>
                      <h6>Expiry Date</h6>
                    </label>
                    <br /><br />
                    <h4>{{ SelectedLom.ExpiryDateTxt }}</h4>
                  </v-col>
                  <v-col cols="12" sm="3" lg="4" md="6">
                    <h6>
                      <span class="text-danger">*</span> Orientation Certificate
                    </h6>
                    <v-file-input
                      :clearable="false"
                      truncate-length="25"
                      accept="application/pdf"
                      placeholder="Upload pdf"
                      v-model="OrientationCertificate"
                      prepend-icon="mdi-file-pdf"
                    >
                      <template v-slot:append-outer>
                        <v-icon
                          color="red"
                          @click="OrientationCertificate = {}"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" sm="3" lg="4" md="6">
                    <h6>
                      <span class="text-danger">*</span> Signed Membership List
                    </h6>
                    <v-file-input
                      :clearable="false"
                      truncate-length="25"
                      accept="application/pdf"
                      placeholder="Upload pdf"
                      v-model="MembershipList"
                      prepend-icon="mdi-file-pdf"
                    >
                      <template v-slot:append-outer>
                        <v-icon color="red" @click="MembershipList = {}">
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-card elevation="3" outlined>
              <v-card-title>
                <span> New LO President Details &nbsp; </span>
              </v-card-title>
              <v-container>
                <v-row wrap>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> First Name</h6>
                    </label>
                    <v-text-field
                      v-model="FirstName"
                      :rules="FirstNameRules"
                      hint="Enter president first name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Middle Name</h6>
                    </label>
                    <v-text-field
                      v-model="MiddleName"
                      :rules="MiddleNameRules"
                      hint="Enter president middle name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Last Name</h6>
                    </label>
                    <v-text-field
                      v-model="LastName"
                      :rules="LastNameRules"
                      hint="Enter president last name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>
                      <h6><span class="text-danger">*</span> Street 1</h6>
                    </label>
                    <v-text-field
                      v-model="Street1"
                      :rules="Street1Rules"
                      hint="Enter president street line 1"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="8">
                    <label>
                      <h6>Street 2</h6>
                    </label>
                    <v-text-field
                      v-model="Street2"
                      :rules="Street2Rules"
                      hint="Enter president street line 2"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Area</h6>
                    </label>
                    <v-text-field
                      v-model="AreaName"
                      :rules="AreaNameRules"
                      hint="Enter president area"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> State</h6>
                    </label>
                    <v-autocomplete
                      @change="getDistrictCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="StateCodeOptionsLoading"
                      :items="StateCodeOptions"
                      :rules="StateCodeRules"
                      v-model="StateCode"
                      required
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> District</h6>
                    </label>
                    <v-autocomplete
                      @change="getCityCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="DistrictCodeOptionsLoading"
                      :items="DistrictCodeOptions"
                      :rules="DistrictCodeRules"
                      v-model="DistrictCode"
                      required
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> City</h6>
                    </label>
                    <v-autocomplete
                      @change="generateSelectedLoName"
                      :reduce="(option) => option.value"
                      :loading="CityCodeOptionsLoading"
                      :items="CityCodeOptions"
                      :rules="CityCodeRules"
                      v-model="CityCode"
                      dense
                      clearable
                      required
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Pincode</h6>
                    </label>
                    <v-text-field
                      v-model="Pincode"
                      :rules="PincodeRules"
                      hint="Enter president pincode"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Mobile No</h6>
                    </label>
                    <v-text-field
                      v-model="PresidentMobileNo"
                      :rules="PresidentMobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="Enter president mobile number"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Email ID</h6>
                    </label>
                    <v-text-field
                      v-model="PresidentEmailId"
                      :rules="PresidentEmailIdRules"
                      hint="Enter president email id"
                      type="email"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Is This A Lady LO?</h6>
                    </label>
                    <v-checkbox
                      v-model="IsLadyLo"
                      label="Yes, this is a Lady LO"
                      color="primary"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-alert
              v-if="IsLadyLo"
              type="warning"
              outlined
              color="orange"
              class="mb-4"
            >
              <strong>⚠️ Important Note:</strong> Since this is a
              <strong>Lady LO</strong>, all members of this LO must be
              <strong>women/ladies only</strong>. Please ensure that membership
              is restricted to female members only.
            </v-alert>

            <v-card elevation="3" outlined>
              <v-card-title>
                <span> New Secretary Details &nbsp; </span>
              </v-card-title>
              <v-container>
                <v-row wrap>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> First Name</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryFirstName"
                      :rules="SecretaryFirstNameRules"
                      hint="Enter secretary first name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Middle Name</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryMiddleName"
                      :rules="SecretaryMiddleNameRules"
                      hint="Enter secretary middle name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Last Name</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryLastName"
                      :rules="SecretaryLastNameRules"
                      hint="Enter secretary last name"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>
                      <h6><span class="text-danger">*</span> Street 1</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryStreet1"
                      :rules="SecretaryStreet1Rules"
                      hint="Enter secretary street line 1"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="8">
                    <label>
                      <h6>Street 2</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryStreet2"
                      :rules="SecretaryStreet2Rules"
                      hint="Enter secretary street line 2"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6>Area</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryAreaName"
                      :rules="SecretaryAreaNameRules"
                      hint="Enter secretary area"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> State</h6>
                    </label>
                    <v-autocomplete
                      @change="getSecretaryDistrictCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="SecretaryStateCodeOptionsLoading"
                      :items="SecretaryStateCodeOptions"
                      :rules="SecretaryStateCodeRules"
                      v-model="SecretaryStateCode"
                      required
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> District</h6>
                    </label>
                    <v-autocomplete
                      @change="getSecretaryCityCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="SecretaryDistrictCodeOptionsLoading"
                      :items="SecretaryDistrictCodeOptions"
                      :rules="SecretaryDistrictCodeRules"
                      v-model="SecretaryDistrictCode"
                      required
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> City</h6>
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="SecretaryCityCodeOptionsLoading"
                      :items="SecretaryCityCodeOptions"
                      :rules="SecretaryCityCodeRules"
                      v-model="SecretaryCityCode"
                      dense
                      clearable
                      required
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Pincode</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryPincode"
                      :rules="SecretaryPincodeRules"
                      hint="Enter secretary pincode"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Mobile No</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryMobileNo"
                      :rules="SecretaryMobileNoRules"
                      :counter="10"
                      v-mask="'##########'"
                      type="number"
                      hint="Enter secretary mobile number"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <label>
                      <h6><span class="text-danger">*</span> Email ID</h6>
                    </label>
                    <v-text-field
                      v-model="SecretaryEmailId"
                      :rules="SecretaryEmailIdRules"
                      hint="Enter secretary email id"
                      type="email"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br /><br />

            <v-card elevation="3" outlined>
              <v-card-title>
                <span> Payment Details &nbsp; </span>
              </v-card-title>
              <v-container>
                <v-row wrap v-if="tableData1.length > 0">
                  <v-col align="center" cols="12" sm="12" md="12">
                    <!-- <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field>-->
                    <br />
                    <v-data-table
                      class="elevation-1"
                      loading-text="Loading... Please wait"
                      disable-sort
                      disable-filtering
                      v-model="selected"
                      :search="search"
                      :loading="TableLoadingFlag"
                      :item-key="tableOptions1.ItemKey"
                      :single-select="tableOptions1.SingleSelectFlag"
                      :headers="tableColumns1"
                      :items="tableData1"
                      :items-per-page="tableOptions1.ItemsPerPage"
                      :footer-props="tableOptions1.FooterProps"
                      :hide-default-footer="tableOptions1.HideDefaultFooter"
                    >
                      <template v-slot:item.FineCheckBox="{ item }">
                        <v-checkbox
                          v-if="item.FineFlag"
                          v-model="item.FinePaidFlag"
                          :label="item.FineAmountTxt"
                          color="info"
                          :value="item.FinePaidFlag"
                          hide-details
                          v-on="calculateTotal()"
                        ></v-checkbox>
                      </template>
                      <template v-slot:item.Qty="{ item }">
                        <v-text-field
                          v-model="item.Qty"
                          v-on="calculateTotal()"
                          type="number"
                          min="0"
                          :rules="QtyRules"
                        ></v-text-field>
                      </template>
                      <template v-slot:item.SubTotal="{ item }">
                        {{ item.SubTotal }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <br />
                <v-row>
                  <v-col align="center" cols="12" sm="12" md="12">
                    <h3 class="text-primary">
                      Total Amount : Rs. {{ TotalAmount }}
                    </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>

            <br />
            <v-row wrap>
              <v-col align="center" cols="12" sm="12" md="12">
                <upload-progress
                  :ProgessStart="ProgessStart"
                  :UploadPercentage="uploadPercentage"
                ></upload-progress>
                <v-btn
                  :disabled="!valid"
                  type="submit"
                  color="success"
                  class="mr-4"
                  @click.prevent="confirmAlert"
                  :loading="SubmitFlag"
                  >Pay now</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      valid: true,
      LoadingFlag: false,
      SubmitFlag: false,
      ProgressLoadingFlag: false,
      StartupLoadingFlag: false,

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      TableLoadingFlag: false,

      TotalAmount: 0,
      Member: {},

      SelectedLom: {},

      MobileNoRules: [(v) => !!v || "Mobile No is required"],

      EmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      QtyRules: [
        (v) => Number.isInteger(Number(v)) || "Nos is invalid",
        (v) => v >= 0 || "Number must be greater than zero",
      ],

      // NewLomCodeRules: [(v) => !!v || "New LO is required"],
      NewLomCode: "",
      NewLomCodeOptions: [],
      NewLomCodeOptionsLoading: false,

      FirstName: "",
      FirstNameRules: [(v) => !!v || "First name is required"],

      MiddleName: "",
      MiddleNameRules: [],

      LastName: "",
      LastNameRules: [],

      Street1: "",
      Street1Rules: [(v) => !!v || "Street 1 is required"],

      Street2: "",
      Street2Rules: [],

      AreaName: "",
      AreaNameRules: [],

      Pincode: "",
      PincodeRules: [(v) => !!v || "Pincode is required"],

      PresidentMobileNo: "",
      PresidentMobileNoRules: [(v) => !!v || "Mobile No is required"],

      PresidentEmailId: "",
      PresidentEmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      StateCodeRules: [(v) => !!v || "State is required"],
      StateCode: "",
      StateCodeOptions: [],
      StateCodeOptionsLoading: false,

      DistrictCodeRules: [(v) => !!v || "District is required"],
      DistrictCode: "",
      DistrictCodeOptions: [],
      DistrictCodeOptionsLoading: false,

      CityCodeRules: [(v) => !!v || "City is required"],
      CityCode: "",
      CityCodeOptions: [],
      CityCodeOptionsLoading: false,

      // Lady LO Flag
      IsLadyLo: false,

      // Secretary Details
      SecretaryFirstName: "",
      SecretaryFirstNameRules: [(v) => !!v || "First name is required"],

      SecretaryMiddleName: "",
      SecretaryMiddleNameRules: [],

      SecretaryLastName: "",
      SecretaryLastNameRules: [],

      SecretaryStreet1: "",
      SecretaryStreet1Rules: [(v) => !!v || "Street 1 is required"],

      SecretaryStreet2: "",
      SecretaryStreet2Rules: [],

      SecretaryAreaName: "",
      SecretaryAreaNameRules: [],

      SecretaryPincode: "",
      SecretaryPincodeRules: [(v) => !!v || "Pincode is required"],

      SecretaryMobileNo: "",
      SecretaryMobileNoRules: [(v) => !!v || "Mobile No is required"],

      SecretaryEmailId: "",
      SecretaryEmailIdRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],

      SecretaryStateCodeRules: [(v) => !!v || "State is required"],
      SecretaryStateCode: "",
      SecretaryStateCodeOptions: [],
      SecretaryStateCodeOptionsLoading: false,

      SecretaryDistrictCodeRules: [(v) => !!v || "District is required"],
      SecretaryDistrictCode: "",
      SecretaryDistrictCodeOptions: [],
      SecretaryDistrictCodeOptionsLoading: false,

      SecretaryCityCodeRules: [(v) => !!v || "City is required"],
      SecretaryCityCode: "",
      SecretaryCityCodeOptions: [],
      SecretaryCityCodeOptionsLoading: false,

      SelectedLoName: "",

      ProgessStart: 0,
      uploadPercentage: 0,

      CurrentYearId: 0,

      ZoneCode: "",
      LomCode: "",
      YearCode: "",
      MonthCode: "",
      MonthName: "",

      OrientationCertificate: {},
      MembershipList: {},
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",

      CartDetails: {},
      Order: {},

      rows: [],
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.JciYearCode = tr.CurrentJciYearId;
        var YearName = tr.CurrentJciYearName;
        this.YearName = YearName;

        var MonthCode = this.$route.query.month;
        MonthCode = MonthCode == (null || undefined) ? 0 : MonthCode;
        console.log({ MonthCode });
        this.MonthCode = MonthCode;

        var tempDate1 = YearName + "-" + MonthCode + "-01";
        console.log({ tempDate1 });

        var tempDate2 = new Date(tempDate1);
        console.log({ tempDate2 });
        var MonthName = tempDate2.toLocaleString("en-us", { month: "long" });
        console.log({ MonthName });
        this.MonthName = MonthName;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;

        var LomCode = this.$session.get("LomId");
        LomCode = LomCode == (null || undefined) ? "" : LomCode;
        console.log("LomCode=" + LomCode);
        this.LomCode = LomCode;

        this.pageData();
      }
    },
    CartDetails: function () {
      console.log("watch CartDetails");
      this.LoadingFlag = false;
      this.TableLoadingFlag = false;
      var tr = this.CartDetails;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var tableOptions = tr.TableOptions;
        this.tableOptions1 = tableOptions;
        this.tableColumns1 = tr.TableHeader;
        this.tableData1 = tr.TableData;
        this.TotalAmount = tableOptions.TotalAmount;
      }
    },
    NewLomCodeOptions: function () {
      console.log("watch NewLomCodeOptions");
      this.LoadingFlag = false;
      this.NewLomCodeOptionsLoading = false;
    },
    StateCodeOptions: function () {
      console.log("watch StateCodeOptions");
      this.LoadingFlag = false;
      this.StateCodeOptionsLoading = false;
    },
    DistrictCodeOptions: function () {
      console.log("watch DistrictCodeOptions");
      this.LoadingFlag = false;
      this.DistrictCodeOptionsLoading = false;
    },
    CityCodeOptions: function () {
      console.log("watch CityCodeOptions");
      this.LoadingFlag = false;
      this.CityCodeOptionsLoading = false;
    },
    SecretaryStateCodeOptions: function () {
      console.log("watch SecretaryStateCodeOptions");
      this.LoadingFlag = false;
      this.SecretaryStateCodeOptionsLoading = false;
    },
    SecretaryDistrictCodeOptions: function () {
      console.log("watch SecretaryDistrictCodeOptions");
      this.LoadingFlag = false;
      this.SecretaryDistrictCodeOptionsLoading = false;
    },
    SecretaryCityCodeOptions: function () {
      console.log("watch SecretaryCityCodeOptions");
      this.LoadingFlag = false;
      this.SecretaryCityCodeOptionsLoading = false;
    },
    LomName: function () {
      console.log("watch LomName");
      this.generateSelectedLoName();
    },
    NewLomCode: function () {
      console.log("watch MemberId");
      var temp_code = this.NewLomCode;
      console.log("temp_code=" + temp_code);
      var idx = this.NewLomCodeOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      var SelectedLom = {};
      if (idx >= 0) {
        SelectedLom = this.NewLomCodeOptions[idx];
        console.log({ SelectedLom });
      }
      this.SelectedLom = SelectedLom;
    },
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    refreshPageData() {
      console.log("refreshPageData called");

      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "new_lo_title",
        Action: "create_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);

      var url2 = "api/new-lom/cart-details";
      var condition2 = {
        UserInterface: 1,
      };
      // this.TableLoadingFlag = true;
      // this.getPageDetails("CartDetails", {}, url2, condition2);
    },
    pageData() {
      console.log("pageData called");
      this.getNewLomCodeOptions();
      this.getStateCodeOptions();
      this.getSecretaryStateCodeOptions();
      this.getMemberDetails();
      this.getRegularSubscriptionList();
    },
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    resetForm() {
      this.$refs.form2.reset();
      this.tableData1 = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getNewLomCodeOptions() {
      console.log("getNewLomCodeOptions called");
      this.LoadingFlag = true;
      this.NewLomCodeOptionsLoading = true;
      var selectbox1_source = "NewLomCode";
      var selectbox1_destination = "NewLomCodeOptions";
      var selectbox1_url = "api/new-lom/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getStateCodeOptions() {
      console.log("getStateCodeOptions called");
      this.LoadingFlag = true;
      this.StateCodeOptionsLoading = true;
      var selectbox1_source = "StateCode";
      var selectbox1_destination = "StateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getDistrictCodeOptions() {
      console.log("getDistrictCodeOptions called");
      var StateCode = this.StateCode;
      console.log({ StateCode });
      if (StateCode != "") {
        this.LoadingFlag = true;
        this.DistrictCodeOptionsLoading = true;
        var selectbox1_source = "DistrictCode";
        var selectbox1_destination = "DistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityCodeOptions() {
      console.log("getCityCodeOptions called");
      var DistrictCode = this.DistrictCode;
      console.log({ DistrictCode });
      if (DistrictCode != "") {
        this.CityCodeOptionsLoading = true;
        var selectbox1_source = "CityCode";
        var selectbox1_destination = "CityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getSecretaryStateCodeOptions() {
      console.log("getSecretaryStateCodeOptions called");
      this.LoadingFlag = true;
      this.SecretaryStateCodeOptionsLoading = true;
      var selectbox1_source = "SecretaryStateCode";
      var selectbox1_destination = "SecretaryStateCodeOptions";
      var selectbox1_url = "api/states/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getSecretaryDistrictCodeOptions() {
      console.log("getSecretaryDistrictCodeOptions called");
      var SecretaryStateCode = this.SecretaryStateCode;
      console.log({ SecretaryStateCode });
      if (SecretaryStateCode != "") {
        this.LoadingFlag = true;
        this.SecretaryDistrictCodeOptionsLoading = true;
        var selectbox1_source = "SecretaryDistrictCode";
        var selectbox1_destination = "SecretaryDistrictCodeOptions";
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: SecretaryStateCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getSecretaryCityCodeOptions() {
      console.log("getSecretaryCityCodeOptions called");
      var SecretaryDistrictCode = this.SecretaryDistrictCode;
      console.log({ SecretaryDistrictCode });
      if (SecretaryDistrictCode != "") {
        this.SecretaryCityCodeOptionsLoading = true;
        var selectbox1_source = "SecretaryCityCode";
        var selectbox1_destination = "SecretaryCityCodeOptions";
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: SecretaryDistrictCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MemberId = this.$session.get("MemberId");
      MemberId = MemberId == (null || undefined) ? "" : MemberId;

      console.log("MemberId=" + MemberId);

      if (MemberId != "") {
        this.StartupLoadingFlag = true;
        this.Member = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/show";
        var upload = {
          UserInterface: 1,
          MemberId: MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              var member = records[0];
              thisIns.Member = member;
              thisIns.MemberImageFlag = true;
              thisIns.Member.EmailId =
                member.EmailId == "NA" ? "" : member.EmailId;
              thisIns.Member.PrimaryMobile =
                member.PrimaryMobile == "NA" ? "" : member.PrimaryMobile;
              // thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message);
      }
    },
    generateSelectedLoName() {
      console.log("generateSelectedLoName called");

      var CityCode = this.CityCode;
      var LomName = this.LomName;
      var SelectedLoName = "";

      if (CityCode != "") {
        var City = this.CityCodeOptions.find((data) => {
          return data.value == CityCode;
        });

        console.log("Selected City=" + JSON.stringify(City));

        SelectedLoName = "jci " + City.text + " " + LomName;
      } else {
        SelectedLoName = "jci {city name} " + LomName;
      }
      SelectedLoName = SelectedLoName.toUpperCase();
      console.log("SelectedLoName=" + SelectedLoName);

      this.SelectedLoName = SelectedLoName;
    },
    getRegularSubscriptionList() {
      console.log("getRegularSubscriptionList is called");

      var JciYearCode = this.JciYearCode;
      console.log("JciYearCode=" + JciYearCode);

      // JciYearCode = "";

      if (JciYearCode != "") {
        this.LoadingFlag = true;
        this.tableData1 = [];

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/year-wise-contribution/lists";
        var upload = {
          UserInterface: 3,
          YearCode: JciYearCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.tableOptions1 = records.TableOptions;

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableData1 = records.TableData;
              thisIns.toast("success", output);
              // thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            this.SearchFlag = false;
          });
      } else {
        var message = "";
        if (JciYearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    calculateTotal() {
      console.log("calculateTotal called");
      var n1 = this.tableData1.length;
      var totalAmount = 0;
      // console.log("n1=" + n1 + ", tableData1=" + JSON.stringify(this.tableData1));
      for (var i = 0; i < n1; i++) {
        var qty = this.tableData1[i]["Qty"];
        var PenaltyAmount = this.tableData1[i]["FineAmount"];
        var WithoutFineAmount = this.tableData1[i]["WithoutFineAmount"];
        var FinePaidFlag = this.tableData1[i]["FinePaidFlag"];
        var amount = this.tableData1[i]["Amount"];
        console.log(
          "i=" +
            i +
            ", qty=" +
            qty +
            ", PenaltyAmount=" +
            PenaltyAmount +
            ", WithoutFineAmount=" +
            WithoutFineAmount +
            ", FinePaidFlag=" +
            FinePaidFlag +
            ", amount=" +
            amount
        );
        amount = FinePaidFlag ? amount : WithoutFineAmount;
        PenaltyAmount = FinePaidFlag ? PenaltyAmount : 0;
        console.log("amount=" + amount + ", PenaltyAmount=" + PenaltyAmount);
        qty = !isNaN(qty) ? (qty >= 0 ? qty : 0) : 0;
        amount = !isNaN(amount) ? amount : 0;
        console.log("qty=" + qty + ", amount=" + amount);
        var subTotal = parseFloat(qty) * parseFloat(amount);
        this.tableData1[i]["PenaltyAmount"] = PenaltyAmount;
        this.tableData1[i]["PenaltyAmountTxt"] = this.getDecimalNumber(
          PenaltyAmount,
          2
        );
        this.tableData1[i]["SubTotal"] = isNaN(subTotal)
          ? 0
          : this.getDecimalNumber(subTotal, 2);
      }
      var totalAmount = this.tableData1.reduce(function (sum, line) {
        var lineTotal = parseFloat(line.SubTotal);
        console.log("lineTotal=" + lineTotal);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);
      console.log("totalAmount=" + totalAmount);
      this.TotalAmount = isNaN(totalAmount)
        ? 0
        : this.getDecimalNumber(totalAmount, 2);
    },
    confirmAlert() {
      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var TotalAmount = this.TotalAmount;
      console.log({ TotalAmount });

      var Member = this.Member;
      console.log({ Member });

      var MemberId = Member.MemberId;
      console.log({ MemberId });

      // TotalAmount = 0;

      if (validate1 && TotalAmount > 0 && MemberId != "") {
        var htmlTxt = "";
        // htmlTxt += "<b>Please verify all the information before proceeding</b>";
        htmlTxt += "<b>Selected New LO details</b>";
        htmlTxt += "<br/><br/>";
        htmlTxt +=
          "Your Mobile Number <b>" + this.Member.PrimaryMobile + "</b><br/>";
        htmlTxt += "Your Email Id <b>" + this.Member.EmailId + "</b><br/>";
        htmlTxt +=
          "Selected LO Name <b>" + this.SelectedLom.NewLomsName + "</b><br/>";
        htmlTxt += "New LO President name <b>" + this.FirstName + "</b><br/>";
        htmlTxt +=
          "New LO President Mobile Number <b>" +
          this.PresidentMobileNo +
          "</b><br/>";
        htmlTxt +=
          "New LO President Email Id <b>" + this.PresidentEmailId + "</b><br/>";

        htmlTxt += "<br/><b>New Secretary Details</b><br/>";
        htmlTxt +=
          "New Secretary name <b>" + this.SecretaryFirstName + "</b><br/>";
        htmlTxt +=
          "New Secretary Mobile Number <b>" +
          this.SecretaryMobileNo +
          "</b><br/>";
        htmlTxt +=
          "New Secretary Email Id <b>" + this.SecretaryEmailId + "</b><br/>";

        htmlTxt += "Amount. <b>" + TotalAmount + "</b><br/>";
        htmlTxt += "<br/><br/>";
        htmlTxt += "Do you want to continue?";
        Swal.fire({
          title: "Please verify all the information before proceeding",
          text: "",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (TotalAmount == 0) {
          message += "Payment details invalid. ";
        }
        if (MemberId == 0) {
          message += "President details invaid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      this.ProgressLoadingFlag = true;
      this.SubmitFlag = true;

      var Member = this.Member;
      console.log({ Member });

      var MemberId = Member.MemberId;
      console.log({ MemberId });

      var SelectedLom = this.SelectedLom;
      console.log({ SelectedLom });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/new-lom-payment/order-create";
      var uploadData = {
        Lom: this.LomCode,
        Member: MemberId,
        MobileNo: Member.PrimaryMobile,
        EmailId: Member.EmailId,
        NewLomName: this.NewLomCode,
        LomState: SelectedLom.StateId,
        FirstName: this.FirstName,
        MiddleName: this.MiddleName,
        LastName: this.LastName,
        NewPresidentMobileNo: this.PresidentMobileNo,
        NewPresidentEmailId: this.PresidentEmailId,
        Street1: this.Street1,
        Street2: this.Street2,
        AreaName: this.AreaName,
        Pincode: this.Pincode,
        States: this.StatesCode,
        District: this.DistrictCode,
        City: this.CityCode,
        IsLadyLo: this.IsLadyLo ? 1 : 0,

        SecretaryFirstName: this.SecretaryFirstName,
        SecretaryMiddleName: this.SecretaryMiddleName,
        SecretaryLastName: this.SecretaryLastName,
        SecretaryMobileNo: this.SecretaryMobileNo,
        SecretaryEmailId: this.SecretaryEmailId,
        SecretaryStreet1: this.SecretaryStreet1,
        SecretaryStreet2: this.SecretaryStreet2,
        SecretaryAreaName: this.SecretaryAreaName,
        SecretaryPincode: this.SecretaryPincode,
        SecretaryState: this.SecretaryStateCode,
        SecretaryDistrict: this.SecretaryDistrictCode,
        SecretaryCity: this.SecretaryCityCode,

        Contribution: this.tableData1,
        TotalAmount: this.TotalAmount,
      };

      let upload = new FormData();
      upload.append("Form", JSON.stringify(uploadData));
      upload.append("UserInterface", 1);
      upload.append("OrientationCertificate", this.OrientationCertificate);
      upload.append("MembershipList", this.MembershipList);

      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;
          thisIns.SubmitFlag = false;

          flag = response.data.flag;
          console.log({ flag });

          output = response.data.output;
          console.log({ output });

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.toast("success", output);
            thisIns.Order = records.Order;
            thisIns.makePayment();
          } else {
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
          thisIns.ProgressLoadingFlag = false;
          console.log({ error });
        });
    },
    makePayment() {
      console.log("makePayment");
      // ev.preventDefault();
      var order = this.Order;
      const thisIns = this;
      var rzp1 = new Razorpay({
        key: order.rzp_key,
        account_id: order.rzp_account_id,
        order_id: order.rzp_order_id,
        amount: order.rzp_amount,
        name: order.rzp_name,
        currency: "INR",
        description: order.rzp_description,
        image: order.rzp_image,
        theme: {
          color: order.rzp_color,
        },
        prefill: {
          name: order.customer_name,
          email: order.customer_email_id,
          contact: order.customer_mobile_no,
        },
        notes: {
          address: "",
        },
        // callback_url: "http://domain.com/#/about/" + this.order_id,
        redirect: false,
        handler: function (response) {
          console.log("razorpay_payment_id=" + response.razorpay_payment_id);
          thisIns.ProgressLoadingFlag = true;
          thisIns.SubmitFlag = true;
          // thisIns.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
          thisIns.pageRedirect({}, "/order/success");
        },
      });
      rzp1.open();
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
/* This is for documentation purposes and will not be needed in your application */

#new-lo-title-create {
  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  .notes-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }

  .notes-content {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }

  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody tr:nth-of-type(odd) {
    background-color: #f5f5f5;
  }
}
</style>